module.exports = __webpack_public_path__ + "img/banner6.b4375e65.jpg";